/* import __COLOCATED_TEMPLATE__ from './intermediate-timing-record-table.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { use } from 'ember-resources';
import { socketRecordTable } from 'bullitttime-embercomponents/utils/socket-record-table-resource';

export default class IntermediateTimingAssociationTableComponent extends Component
{
	@tracked timingRecordForContextMenu = null;

	@service ajax;
	@service socketGuru;

	// Rebuilds whenever a tracked read in this thunk changes — here @event and
	// @timingPointId. The @timingPointId dependency replaces the old
	// {{did-update this.fetchInitialRecords @timingPointId}} modifier.
	@use intermediateRecords = socketRecordTable(() =>
	{
		const { event, timingPointId } = this.args;
		return {
			socketGuru: this.socketGuru,
			ajax: this.ajax,
			channels: 'intermediateTimingRecord',
			endpoint: () => (timingPointId != 0 && timingPointId != null)
				? `/intermediate-timing-points/${timingPointId}/timingRecords`
				: null,
			transform: (record) => this.transformRecord(record, event, timingPointId),
			sort: this.sortFn,
		};
	});

	transformRecord(record, event, timingPointId)
	{
		//filter out records for other timing points for this event
		if(record.timingPointId != timingPointId)
		{
			return null;
		}
		if(!event || record.eventId != event.id)
		{
			return null;
		}
		record.color = this.recordColor(record);
		return record;
	}

	sortFn(a,b)
	{
		var aTime = a.impulseTime || a.entryTime;
		var bTime = b.impulseTime || b.entryTime;
		if(aTime == undefined)
			aTime = null;
		if(bTime == undefined)
			bTime = null;
		return aTime>bTime ? -1 : aTime<bTime ? 1 : (a.id>b.id?1:-1)  ;
	}

	recordColor(record)
	{
		if(record.participatesInAutoAssociation == false)
		{
			return "table-warning";
		}
		if(record.isPosted == true)
		{
			return "table-info";
		}
	}

	@action
	click()
	{
		this.timingRecordForContextMenu = null;
		const menu = document.getElementById("context-menu");
		menu.style.display = "none";
		menu.classList.add("hide");
	}

	@action
	bibClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.bibRecordSelectedAction(timingRecord);
	}

	@action
	timeClicked(timingRecord)
	{
		if(this.timingRecordForContextMenu == null)
			this.args.timeRecordSelectAction(timingRecord);
	}

	@action
	contextMenu(timingRecord,browserEvent)
	{
		browserEvent.preventDefault();

		this.timingRecordForContextMenu = timingRecord;

		const menu = document.getElementById("context-menu");
		menu.querySelector("#auto").classList.toggle("active", timingRecord.participatesInAutoAssociation);
		menu.querySelector("#posted").classList.toggle("active", timingRecord.isPosted);
		menu.querySelector("#clearEntry").classList.toggle("disabled", timingRecord.EntryId == null);
		menu.querySelector("#disassociateBib").classList.toggle("disabled",
			!(timingRecord.EntryId != null && timingRecord.impulseId != null));
		const tableRect = document.getElementById("intermediateTimingRecordTable").getBoundingClientRect();
		menu.style.display = "block";
		menu.style.top = (browserEvent.clientY - (tableRect.top + window.scrollY) - 20) + "px";
		menu.style.left = (browserEvent.clientX - (tableRect.left + window.scrollX)) + "px";
		menu.classList.add("show");
		return false;
	}

	@action
	contextMenuAuto()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.participatesInAutoAssociation)
		{
			this.ajax.request("/intermediate-timing-records/"+tr.id+"/removeFromAutoAssociation").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		else
		{
			this.ajax.request("/intermediate-timing-records/"+tr.id+"/addToAutoAssociation").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}

	@action
	contextMenuPosted()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.isPosted)
		{
			this.ajax.request("/intermediate-timing-records/"+tr.id+"/clearPosted").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		else
		{
			this.ajax.request("/intermediate-timing-records/"+tr.id+"/setPosted").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}

	@action
	contextMenuClearEntry()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.EntryId != null)
		{
			this.ajax.request("/intermediate-timing-records/"+tr.id+"/clearEntry").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}

	@action
	contextMenuDisassociateBib()
	{
		var tr = this.timingRecordForContextMenu;
		if(tr == null)
		{
			return;
		}
		if(tr.EntryId != null && tr.impulseId != null)
		{
			this.ajax.request("/intermediate-timing-records/"+tr.id+"/disassociateBibRecord").then(function(response)
			{
				if(response.error != null)
					alert(response.error);
			});
		}
		this.click();
	}
}
